export const DURATION = {
  show: 4,
}
